module.exports = __webpack_public_path__ + "img/order_bg.288537a3.png";